import { usePaginatedApi } from "../../../swr/useApi";
import { purchaseOrdersService } from "../../api_client";
import type {
    PurchaseOrderDto,
    SalesQueryDto,
} from "../../../api";

export function usePurchaseOrders(query?: SalesQueryDto) {
    return usePaginatedApi<PurchaseOrderDto, SalesQueryDto>({
        key: "purchase-orders",
        serviceMethod: async (queryParams) => await purchaseOrdersService.getPurchaseOrders(queryParams),
        query: query,
        options: { refreshInterval: 30_000 },
    });
}

